/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

//CREATING A DATA SLICE
const objectivesSlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "objectives",

  //STATE PROPERTIES INCLUDED IN THIS SLICE
  initialState: {
    // HEALTH DECLARATION
    haveMedicalCondition: "",
    medConditionDesc: "",
    isMedPolicyAcknowledged: "",

    //PROTECTION
    protection: {
      familyAndAssets: {
        priority: "",
        incMonthlyAmt: "0.00",
        incAnnualAmt: "0.00",
        incYearsRequired: "0",
        incPctReturnRate: "0.00",
        incPctInfRate: "0.00",
        incPctInfAdjRate: "0.00",
        incTotaldSettlementFunds: "0.00",

        liaMortgage: "0.00",
        liaDebt: "0.00",
        liaDepEducation: "0.00",
        liaFinalExpenses: "0.00",
        liaOtherDesc: "",
        liaOtherAmt: "0.00",
        liaTotaldSettlementFunds: "0.00",

        resLifeInsuranceCover: "0.00",
        resCashAssets: "0.00",
        resCpf: "0.00",
        resInvestments: "0.00",
        resOthersDesc: "",
        resOthersAmt: "0.00",
        resTotalResources: "0.00",

        totalRequiredFunds: "0.00",
        surplusShortfall: "0.00",
        deviationReason: "",
      },

      disability: {
        priority: "",
        disMonthlyAmt: "0.00",
        disAnnualAmt: "0.00",
        disYearsRequired: "0",
        disPctReturnRate: "0.00",
        disPctInfRate: "0.00",
        disPctInfAdjRate: "0.00",
        disFundsRequired: "0.00",

        disMedicalExpAmt: "0.00",
        disOtherDesc: "",
        disOtherAmt: "0.00",
        disTotalExpenses: "0.00",

        disResTpd: "0.00",
        disResOtherDesc: "",
        disResOtherAmt: "0.00",
        disResTotalResources: "0.00",

        disTotalRequiredFunds: "0.00",
        disSurplusShortfall: "0.00",
        deviationReason: "",
      },

      criticalIlness: {
        priority: "",
        criMonthlyAmt: "0.00",
        criAnnualAmt: "0.00",
        criYearsRequired: "0",
        criPctReturnRate: "0.00",
        criPctInfRate: "0.00",
        criPctInfAdjRate: "0.00",
        criFundsRequired: "0.00",
        criLumpSum: "0.00",
        criOtherDesc: "",
        criOtherAmt: "0.00",
        criTotalNeeds: "0.00",

        resLifeInsuranceCover: "0.00",
        resCashAssets: "0.00",
        resOthersDesc: "",

        resOthersAmt: "0.00",
        resTotalResources: "0.00",

        criSurplusShortfall: "0.00",
        deviationReason: "",
      },

      longTermCare: {
        priority: "",
        ltcNeedsMonthly: "0.00",
        ltcPreferredPayoutPeriod: "0",
        ltcCurrBenefitsMonthly: "0.00",
        ltcSurplysShortfall: "0.00",
        deviationReason: "",
      },

      hospitalization: {
        priority: "",

        hsHospitalType: "",
        hsGovRestructured: "",
        hsProvDeductCoInsurance: "",
        hsCurrHospitalCover: "",
        hsInsurerNameAndType: "",

        deviationReason: "",
      },

      personalAccident: {
        priority: "",

        paNeedsAmt: "0.00",
        paExistingResource: "0.00",
        paSurplusShortfall: "0.00",

        deviationReason: "",
      },

      pregnancy: {
        priority: "",

        prgFetusCount: "0",
        prgCoverateAmt: "0.00",
        prgTotalFundsRequired: "0.00",
        prgExistingResource: "0.00",
        prgSurplusShortfall: "0.00",

        deviationReason: "",
      },

      dependantNeeds: {
        priority: "",

        depName1: "",
        depName2: "",
        depName3: "",
        depName4: "",

        deviationReason: "",
      },
    },

    //WEALTH ACCUMULATION
    wealthaccumulation: {
      retirementPlanning: {
        priority: "",

        retireAge: "0",
        yearsToRetire: "0",
        mthRetireIncToday: "0.00",
        annRetireIncToday: "0.00",
        pctInfRate: "0",

        mthRetireIncDesired: "0.00",
        annRetireIncDesired: "0.00",
        pctReturnRate: "0",
        pctInfAdjRate: "0",
        yearsToProvideForRetire: "0",

        fundsReqAtRetireAge: "0.00",
        liabilityAtRetirement: "0.00",
        totalRetireFundNeeded: "0.00",

        resLifeInsCashValueRoi: "0",
        resLifeInsCashValue: "0.00",
        resCashAssetsRoi: "0",
        resCashAssets: "0.00",
        resInvestmentsRoi: "0",
        resInvestments: "0.00",
        resOtherDesc: "",
        resOtherDescRoi: "0",
        resOtherDescAmt: "0.00",

        fundAvailAtRetireAge: "0.00",
        surplusShortfall: "0.00",

        deviationReason: "",
      },

      childrenEducation: {
        priority: "",

        nameOfChild: "",
        yearToUni: "0",
        annEduCost: "0.00",
        pctInfRate: "0",
        courseDuration: "0",
        fundsRequired: "0.00",

        resLifeInsCashValueRoi: "0",
        resLifeInsCashValue: "0.00",
        resCashAssetsRoi: "0",
        resCashAssets: "0.00",
        resInvestmentsRoi: "0",
        resInvestments: "0.00",
        resOtherDesc: "",
        resOtherDescRoi: "0",
        resOtherDescAmt: "0.00",

        fundAvailAtRetireAge: "0.00",
        surplusShortfall: "0.00",

        deviationReason: "",
      },

      otherPurpose: {
        priority: "",

        purpose: "",
        targetAmount: "0.00",
        yearsToTarget: "0",

        resCashAssets: "0.00",
        resInvestments: "0.00",
        resRateOfReturn: "0.00",
        fvOfCurrSavAndInv: "0.00",
        surplusShortfall: "0.00",

        deviationReason: "",
      },
    },

    //WEALTH PRESERVATION
    wealthpreservation: {
      srs: {
        priority: "",
      },

      estatePlanning: {
        priority: "",
      },

      wealthPreservationDesc: "",
    },
  },

  //REDUCERS INSIDE EACH SLICE DECLARATION CAN PERFORM ACTION ON EACH DATA STATES
  reducers: {
    updateObjectives: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "haveMedicalCondition":
          state.haveMedicalCondition = payload;
          break;

        case "medConditionDesc":
          state.medConditionDesc = payload;
          break;

        case "isMedPolicyAcknowledged":
          state.isMedPolicyAcknowledged = payload;
          break;

        default:
          break;
      }
    },

    updateProtection: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "familyAndAssets":
          state.protection.familyAndAssets.priority = payload;
          break;

        case "disability":
          state.protection.disability.priority = payload;
          break;

        case "criticalIlness":
          state.protection.criticalIlness.priority = payload;
          break;

        case "longtermcare":
          state.protection.longTermCare.priority = payload;
          break;

        case "hospitalization":
          state.protection.hospitalization.priority = payload;
          break;

        case "personalAccident":
          state.protection.personalAccident.priority = payload;
          break;

        case "pregnancy":
          state.protection.pregnancy.priority = payload;
          break;

        case "dependantNeeds":
          state.protection.dependantNeeds.priority = payload;
          break;

        default:
          break;
      }
    },

    updateWealthAccumulation: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "retirementPlanning":
          state.wealthaccumulation.retirementPlanning.priority = payload;
          break;

        case "childrenEducation":
          state.wealthaccumulation.childrenEducation.priority = payload;
          break;

        case "otherPurpose":
          state.wealthaccumulation.otherPurpose.priority = payload;
          break;

        default:
          break;
      }
    },

    updateWealthPreservation: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "srs":
          state.wealthpreservation.srs.priority = payload;
          break;

        case "estateplanning":
          state.wealthpreservation.estatePlanning.priority = payload;
          break;

        case "wealthPreservationDesc":
          state.wealthpreservation.wealthPreservationDesc = payload;
          break;

        default:
          break;
      }
    },

    updateFamilyAndAssets: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        /**==============================
         * INCOME
         ==============================*/
        case "incMonthlyAmt":
          state.protection.familyAndAssets.incMonthlyAmt = payload;
          break;

        case "incAnnualAmt":
          state.protection.familyAndAssets.incAnnualAmt = payload;
          break;

        case "incYearsRequired":
          state.protection.familyAndAssets.incYearsRequired = payload;
          break;

        case "incPctReturnRate":
          state.protection.familyAndAssets.incPctReturnRate = payload;
          break;

        case "incPctInfRate":
          state.protection.familyAndAssets.incPctInfRate = payload;
          break;

        case "incPctInfAdjRate":
          state.protection.familyAndAssets.incPctInfAdjRate = payload;
          break;

        case "incTotaldSettlementFunds":
          state.protection.familyAndAssets.incTotaldSettlementFunds = payload;
          break;

        /**==============================
         * LIABILITY
         ==============================*/
        case "liaMortgage":
          state.protection.familyAndAssets.liaMortgage = payload;
          break;

        case "liaDebt":
          state.protection.familyAndAssets.liaDebt = payload;
          break;

        case "liaDepEducation":
          state.protection.familyAndAssets.liaDepEducation = payload;
          break;

        case "liaFinalExpenses":
          state.protection.familyAndAssets.liaFinalExpenses = payload;
          break;

        case "liaOtherDesc":
          state.protection.familyAndAssets.liaOtherDesc = payload;
          break;

        case "liaOtherAmt":
          state.protection.familyAndAssets.liaOtherAmt = payload;
          break;

        case "liaTotaldSettlementFunds":
          state.protection.familyAndAssets.liaTotaldSettlementFunds = payload;
          break;

        /**==============================
           * RESOURCECS
           ==============================*/
        case "resLifeInsuranceCover":
          state.protection.familyAndAssets.resLifeInsuranceCover = payload;
          break;

        case "resCashAssets":
          state.protection.familyAndAssets.resCashAssets = payload;
          break;

        case "resCpf":
          state.protection.familyAndAssets.resCpf = payload;
          break;

        case "resInvestments":
          state.protection.familyAndAssets.resInvestments = payload;
          break;

        case "resOthersDesc":
          state.protection.familyAndAssets.resOthersDesc = payload;
          break;

        case "resOthersAmt":
          state.protection.familyAndAssets.resOthersAmt = payload;
          break;

        case "resTotalResources":
          state.protection.familyAndAssets.resTotalResources = payload;
          break;

        /**==============================
           * TOTALS & TEXT
           ==============================*/
        case "totalRequiredFunds":
          state.protection.familyAndAssets.totalRequiredFunds = payload;
          break;

        case "surplusShortfall":
          state.protection.familyAndAssets.surplusShortfall = payload;
          break;

        case "deviationReason":
          state.protection.familyAndAssets.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updateDisability: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        /**==============================
         * DISABILITY - INCOME
         ==============================*/
        case "disMonthlyAmt":
          state.protection.disability.disMonthlyAmt = payload;
          break;

        case "disAnnualAmt":
          state.protection.disability.disAnnualAmt = payload;
          break;

        case "disYearsRequired":
          state.protection.disability.disYearsRequired = payload;
          break;

        case "disPctReturnRate":
          state.protection.disability.disPctReturnRate = payload;
          break;

        case "disPctInfRate":
          state.protection.disability.disPctInfRate = payload;
          break;

        case "disPctInfAdjRate":
          state.protection.disability.disPctInfAdjRate = payload;
          break;

        case "disFundsRequired":
          state.protection.disability.disFundsRequired = payload;
          break;

        /**==============================
         * DISABILITY - EXPENSES
         ==============================*/
        case "disMedicalExpAmt":
          state.protection.disability.disMedicalExpAmt = payload;
          break;

        case "disOtherDesc":
          state.protection.disability.disOtherDesc = payload;
          break;

        case "disOtherAmt":
          state.protection.disability.disOtherAmt = payload;
          break;

        case "disTotalExpenses":
          state.protection.disability.disTotalExpenses = payload;
          break;

        /**==============================
         * DISABILITY - ALLOCATED RESOURCES
         ==============================*/
        case "disResTpd":
          state.protection.disability.disResTpd = payload;
          break;

        case "disResOtherDesc":
          state.protection.disability.disResOtherDesc = payload;
          break;

        case "disResOtherAmt":
          state.protection.disability.disResOtherAmt = payload;
          break;

        case "disResTotalResources":
          state.protection.disability.disResTotalResources = payload;
          break;

        case "disTotalRequiredFunds":
          state.protection.disability.disTotalRequiredFunds = payload;
          break;

        case "disSurplusShortfall":
          state.protection.disability.disSurplusShortfall = payload;
          break;

        case "deviationReason":
          state.protection.disability.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updateCriticalIllness: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        /**==============================
         * CRITICAL ILLNESS - NEEDS
         ==============================*/
        case "criMonthlyAmt":
          state.protection.criticalIlness.criMonthlyAmt = payload;
          break;

        case "criAnnualAmt":
          state.protection.criticalIlness.criAnnualAmt = payload;
          break;

        case "criYearsRequired":
          state.protection.criticalIlness.criYearsRequired = payload;
          break;

        case "criPctReturnRate":
          state.protection.criticalIlness.criPctReturnRate = payload;
          break;

        case "criPctInfRate":
          state.protection.criticalIlness.criPctInfRate = payload;
          break;

        case "criPctInfAdjRate":
          state.protection.criticalIlness.criPctInfAdjRate = payload;
          break;

        case "criFundsRequired":
          state.protection.criticalIlness.criFundsRequired = payload;
          break;

        case "criLumpSum":
          state.protection.criticalIlness.criLumpSum = payload;
          break;

        case "criOtherDesc":
          state.protection.criticalIlness.criOtherDesc = payload;
          break;

        case "criOtherAmt":
          state.protection.criticalIlness.criOtherAmt = payload;
          break;

        case "criTotalNeeds":
          state.protection.criticalIlness.criTotalNeeds = payload;
          break;

        /**==============================
         * CRITICAL ILLNESS - ALLOCATED RESOURCES
         ==============================*/
        case "resLifeInsuranceCover":
          state.protection.criticalIlness.resLifeInsuranceCover = payload;
          break;

        case "resCashAssets":
          state.protection.criticalIlness.resCashAssets = payload;
          break;

        case "resOthersDesc":
          state.protection.criticalIlness.resOthersDesc = payload;
          break;

        case "resOthersAmt":
          state.protection.criticalIlness.resOthersAmt = payload;
          break;

        case "resTotalResources":
          state.protection.criticalIlness.resTotalResources = payload;
          break;

        /**==============================
         * CRITICAL ILLNESS - SURPLUS AND SHORTFALL
         ==============================*/
        case "criSurplusShortfall":
          state.protection.criticalIlness.criSurplusShortfall = payload;
          break;

        case "deviationReason":
          state.protection.criticalIlness.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updateLongTermCare: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "ltcNeedsMonthly":
          state.protection.longTermCare.ltcNeedsMonthly = payload;
          break;

        case "ltcPreferredPayoutPeriod":
          state.protection.longTermCare.ltcPreferredPayoutPeriod = payload;
          break;

        case "ltcCurrBenefitsMonthly":
          state.protection.longTermCare.ltcCurrBenefitsMonthly = payload;
          break;

        case "ltcSurplysShortfall":
          state.protection.longTermCare.ltcSurplysShortfall = payload;
          break;

        case "deviationReason":
          state.protection.longTermCare.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updateHospitalization: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "hsHospitalType":
          state.protection.hospitalization.hsHospitalType = payload;
          break;

        case "hsGovRestructured":
          state.protection.hospitalization.hsGovRestructured = payload;
          break;

        case "hsProvDeductCoInsurance":
          state.protection.hospitalization.hsProvDeductCoInsurance = payload;
          break;

        case "hsCurrHospitalCover":
          state.protection.hospitalization.hsCurrHospitalCover = payload;
          break;

        case "hsInsurerNameAndType":
          state.protection.hospitalization.hsInsurerNameAndType = payload;
          break;

        case "deviationReason":
          state.protection.hospitalization.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updatePersonalAccident: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "paNeedsAmt":
          state.protection.personalAccident.paNeedsAmt = payload;
          break;

        case "paExistingResource":
          state.protection.personalAccident.paExistingResource = payload;
          break;

        case "paSurplusShortfall":
          state.protection.personalAccident.paSurplusShortfall = payload;
          break;

        case "deviationReason":
          state.protection.personalAccident.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updatePregnancy: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "prgFetusCount":
          state.protection.pregnancy.prgFetusCount = payload;
          break;

        case "prgCoverateAmt":
          state.protection.pregnancy.prgCoverateAmt = payload;
          break;

        case "prgTotalFundsRequired":
          state.protection.pregnancy.prgTotalFundsRequired = payload;
          break;

        case "prgExistingResource":
          state.protection.pregnancy.prgExistingResource = payload;
          break;

        case "prgSurplusShortfall":
          state.protection.pregnancy.prgSurplusShortfall = payload;
          break;

        case "deviationReason":
          state.protection.pregnancy.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updateDependantNeeds: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "depName1":
          state.protection.dependantNeeds.depName1 = payload;
          break;

        case "depName2":
          state.protection.dependantNeeds.depName2 = payload;
          break;

        case "depName3":
          state.protection.dependantNeeds.depName3 = payload;
          break;

        case "depName4":
          state.protection.dependantNeeds.depName4 = payload;
          break;

        case "deviationReason":
          state.protection.dependantNeeds.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updateRetirementPlanning: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "retireAge":
          state.wealthaccumulation.retirementPlanning.retireAge = payload;
          break;

        case "yearsToRetire":
          state.wealthaccumulation.retirementPlanning.yearsToRetire = payload;
          break;

        case "mthRetireIncToday":
          state.wealthaccumulation.retirementPlanning.mthRetireIncToday = payload;
          break;

        case "annRetireIncToday":
          state.wealthaccumulation.retirementPlanning.annRetireIncToday = (payload * 12).toFixed(2);
          break;

        case "pctInfRate":
          state.wealthaccumulation.retirementPlanning.pctInfRate = payload;
          break;

        case "mthRetireIncDesired":
          state.wealthaccumulation.retirementPlanning.mthRetireIncDesired = payload;
          break;

        case "annRetireIncDesired":
          state.wealthaccumulation.retirementPlanning.annRetireIncDesired = payload;
          break;

        case "pctReturnRate":
          state.wealthaccumulation.retirementPlanning.pctReturnRate = payload;
          break;

        case "pctInfAdjRate":
          state.wealthaccumulation.retirementPlanning.pctInfAdjRate = payload;
          break;

        case "yearsToProvideForRetire":
          state.wealthaccumulation.retirementPlanning.yearsToProvideForRetire = payload;
          break;

        case "fundsReqAtRetireAge":
          state.wealthaccumulation.retirementPlanning.fundsReqAtRetireAge = payload;
          break;

        case "liabilityAtRetirement":
          state.wealthaccumulation.retirementPlanning.liabilityAtRetirement = payload;
          break;

        case "totalRetireFundNeeded":
          state.wealthaccumulation.retirementPlanning.totalRetireFundNeeded = payload;
          break;

        case "resLifeInsCashValueRoi":
          state.wealthaccumulation.retirementPlanning.resLifeInsCashValueRoi = payload;
          break;

        case "resLifeInsCashValue":
          state.wealthaccumulation.retirementPlanning.resLifeInsCashValue = payload;
          break;

        case "resCashAssetsRoi":
          state.wealthaccumulation.retirementPlanning.resCashAssetsRoi = payload;
          break;

        case "resCashAssets":
          state.wealthaccumulation.retirementPlanning.resCashAssets = payload;
          break;

        case "resInvestmentsRoi":
          state.wealthaccumulation.retirementPlanning.resInvestmentsRoi = payload;
          break;

        case "resInvestments":
          state.wealthaccumulation.retirementPlanning.resInvestments = payload;
          break;

        case "resOtherDesc":
          state.wealthaccumulation.retirementPlanning.resOtherDesc = payload;
          break;

        case "resOtherDescRoi":
          state.wealthaccumulation.retirementPlanning.resOtherDescRoi = payload;
          break;

        case "resOtherDescAmt":
          state.wealthaccumulation.retirementPlanning.resOtherDescAmt = payload;
          break;

        case "fundAvailAtRetireAge":
          state.wealthaccumulation.retirementPlanning.fundAvailAtRetireAge = payload;
          break;

        case "surplusShortfall":
          state.wealthaccumulation.retirementPlanning.surplusShortfall = payload;
          break;

        case "deviationReason":
          state.wealthaccumulation.retirementPlanning.deviationReason = payload;
          break;

        default:
          break;
      }
    },

    updateChildrenEducation: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "nameOfChild":
          state.wealthaccumulation.childrenEducation.nameOfChild = payload;
          break;

        case "yearToUni":
          state.wealthaccumulation.childrenEducation.yearToUni = payload;
          break;

        case "annEduCost":
          state.wealthaccumulation.childrenEducation.annEduCost = payload;
          break;

        case "pctInfRate":
          state.wealthaccumulation.childrenEducation.pctInfRate = payload;
          break;

        case "courseDuration":
          state.wealthaccumulation.childrenEducation.courseDuration = payload;
          break;

        case "fundsRequired":
          state.wealthaccumulation.childrenEducation.fundsRequired = payload;
          break;

        case "deviationReason":
          state.wealthaccumulation.childrenEducation.deviationReason = payload;
          break;

        case "resLifeInsCashValueRoi":
          state.wealthaccumulation.childrenEducation.resLifeInsCashValueRoi = payload;
          break;

        case "resLifeInsCashValue":
          state.wealthaccumulation.childrenEducation.resLifeInsCashValue = payload;
          break;

        case "resCashAssetsRoi":
          state.wealthaccumulation.childrenEducation.resCashAssetsRoi = payload;
          break;

        case "resCashAssets":
          state.wealthaccumulation.childrenEducation.resCashAssets = payload;
          break;

        case "resInvestmentsRoi":
          state.wealthaccumulation.childrenEducation.resInvestmentsRoi = payload;
          break;

        case "resInvestments":
          state.wealthaccumulation.childrenEducation.resInvestments = payload;
          break;

        case "resOtherDesc":
          state.wealthaccumulation.childrenEducation.resOtherDesc = payload;
          break;

        case "resOtherDescRoi":
          state.wealthaccumulation.childrenEducation.resOtherDescRoi = payload;
          break;

        case "resOtherDescAmt":
          state.wealthaccumulation.childrenEducation.resOtherDescAmt = payload;
          break;

        case "fundAvailAtRetireAge":
          state.wealthaccumulation.childrenEducation.fundAvailAtRetireAge = payload;
          break;

        case "surplusShortfall":
          state.wealthaccumulation.childrenEducation.surplusShortfall = payload;
          break;

        default:
          break;
      }
    },

    updateOtherPurpose: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        case "purpose":
          state.wealthaccumulation.otherPurpose.purpose = payload;
          break;

        case "targetAmount":
          state.wealthaccumulation.otherPurpose.targetAmount = payload;
          break;

        case "yearsToTarget":
          state.wealthaccumulation.otherPurpose.yearsToTarget = payload;
          break;

        case "resCashAssets":
          state.wealthaccumulation.otherPurpose.resCashAssets = payload;
          break;

        case "resInvestments":
          state.wealthaccumulation.otherPurpose.resInvestments = payload;
          break;

        case "resRateOfReturn":
          state.wealthaccumulation.otherPurpose.resRateOfReturn = payload;
          break;

        case "fvOfCurrSavAndInv":
          state.wealthaccumulation.otherPurpose.fvOfCurrSavAndInv = payload;
          break;

        case "surplusShortfallv":
          state.wealthaccumulation.otherPurpose.surplusShortfallvs = payload;
          break;

        case "deviationReason":
          state.wealthaccumulation.otherPurpose.deviationReason = payload;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const {
  updateObjectives,
  updateProtection,
  updateWealthAccumulation,
  updateWealthPreservation,
  updateFamilyAndAssets,
  updateDisability,
  updateCriticalIllness,
  updateLongTermCare,
  updateHospitalization,
  updatePersonalAccident,
  updatePregnancy,
  updateDependantNeeds,

  updateRetirementPlanning,
  updateChildrenEducation,
  updateOtherPurpose,
} = objectivesSlice.actions;

export default objectivesSlice.reducer;
